import { apiSlice } from './apiSlice'

export interface AchievementResult {
  case_id: string
  case_title: string
  round_id: string
  rank: number
  average_score: number
  total_score: number
  advanced: boolean
  published_at?: string
  title?: string
}

export interface AchievementsResponse {
  team_id: string
  team_name: string
  university: string
  results: AchievementResult[]
  summary: AchievementResult[]
}

export const achievementsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyAchievements: builder.query<AchievementsResponse, void>({
      query: () => '/achievements/me',
    }),
    downloadCertificate: builder.query<Blob, string>({
      query: (caseId) => ({
        url: `/achievements/certificate/${caseId}`,
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
})

export const {
  useGetMyAchievementsQuery,
  useLazyDownloadCertificateQuery,
} = achievementsApi
